export default "__VITE_ASSET__405b4ef6__"